//@flow
import React from 'react';
import { graphql } from 'react-relay';
import QueryLookupRenderer from 'relay-query-lookup-renderer';
import getter from 'dibs-object-getter';
import MoreProjects from './MoreProjects';

import type { RelayProp } from 'react-relay';

type MoreProjectsContainerProps = {
    relay?: RelayProp,
    firmId?: ?string,
    projectId?: ?string,
};

export const MoreProjectsContainer = (_props: MoreProjectsContainerProps) => {
    const { firmId, projectId, relay } = _props;

    if (!firmId || !projectId || !relay) {
        return null;
    }

    return (
        <QueryLookupRenderer
            key={firmId}
            lookup
            retain
            environment={relay.environment}
            variables={{ firmId: Number(firmId) }}
            query={graphql`
                query MoreProjectsContainerQuery($firmId: Int!) {
                    viewer {
                        tradeFirm(id: $firmId) {
                            ...MoreProjects_tradeFirm
                        }
                    }
                }
            `}
            render={({ props, error }) => {
                const isLoading = !(props || error);

                if (error) {
                    return null;
                }

                const tradeFirm = getter(props)
                    .at('viewer')
                    .value('tradeFirm');

                return (
                    <MoreProjects
                        isLoading={isLoading}
                        tradeFirm={(tradeFirm: ?Object)}
                        projectId={projectId}
                    />
                );
            }}
        />
    );
};

export default MoreProjectsContainer;
